import { View } from 'react-native';

export const VerticalSpacer10 = () => <View style={{ height: 10 }} />;
export const VerticalSpacer20 = () => <View style={{ height: 20 }} />;
export const FlexSpacer = () => <View style={{ flex: 1 }} />;
